export const INCREASE_STEPPER = 'increase_stepper'
export const DECREASE_STEPPER = 'decrease_stepper'
export const DOUBLE_INCREASE_STEPPER = 'double_increase_stepper'
export const REGISTER_ERROR = 'register_error'
export const SET_CURRENT_ACTIVE_SCREEN = 'update_current_active_screen'